import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/TextInput' /* webpackChunkName: "TextInput" */),
    import('./viewer/TextInput.controller' /* webpackChunkName: "TextInput" */),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('TextInput', UiTypes),
};

export default entry;
